module.exports = __webpack_public_path__ + "img/21.c180c84f.jpg";